export default "__VITE_ASSET__Cswzq_ot__"